import {
    GET_LABS_LIST_REQUEST,
    GET_LABS_LIST_SUCCESS,
    GET_LABS_LIST_FAIL,
    GET_BLOCKED_LIST_REQUEST,
    GET_BLOCKED_LIST_SUCCESS,
    GET_BLOCKED_LIST_FAIL,
    GET_ALLLABS_LIST_REQUEST,
    GET_ALLLABS_LIST_SUCCESS,
    GET_ALLLABS_LIST_FAIL,
    DELETE_LAB_REQUEST,
    DELETE_LAB_SUCCESS,
    DELETE_LAB_FAIL,
    GET_REVIEWS_REQUEST,
    GET_REVIEWS_SUCCESS,
    GET_REVIEWS_FAIL,
    GET_EQA_REQUEST,
    GET_EQA_SUCCESS,
    GET_EQA_FAIL,
    UNBLOCK_LAB_REQUEST,
    UNBLOCK_LAB_SUCCESS,
    UNBLOCK_LAB_FAIL,
    DELETEP_LAB_REQUEST,
    DELETEP_LAB_SUCCESS,
    DELETEP_LAB_FAIL,
    VERIFY_LAB_REQUEST,
    VERIFY_LAB_SUCCESS,
    VERIFY_LAB_FAIL,
    GET_LAB_DETAIL,
    GET_LAB_DETAIL_SUCCESS,
    GET_LAB_DETAIL_FAIL,
   UPDATE_LAB_REQUEST,
   UPDATE_LAB_SUCCESS,
   UPDATE_LAB_FAIL,
   UPLOAD_REQUEST,
   UPLOAD_SUCCESS,
   UPLOAD_FAILURE,
} from './actionTypes';
const INIT_STATE = {
    labs: [],
    blocked:[],
    error: "",
    file: "",
    reviews:[],
    eqas:[],
  isLoading: false,
    lab: {},
}
const LabReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case GET_LABS_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_LABS_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                labs: action.payload,
            };
        case GET_LABS_LIST_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case GET_BLOCKED_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_BLOCKED_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                labs: action.payload,
            };
        case GET_BLOCKED_LIST_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
            //GETTING ALL VERIFIED LABS LIST
        case  GET_ALLLABS_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
            case GET_REVIEWS_REQUEST:
                return {
                    ...state,
                    isLoading: true,
                    error: null,
                };
            case GET_REVIEWS_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    reviews: action.payload,
                };
            case GET_REVIEWS_FAIL:
                return {
                    ...state,
                    isLoading: false,
                    error: action.payload,
                };
                case GET_EQA_REQUEST:
                    return {
                        ...state,
                        isLoading: true,
                        error: null,
                    };
                case GET_EQA_SUCCESS:
                    return {
                        ...state,
                        isLoading: false,
                        eqas: action.payload,
                    };
                case GET_EQA_FAIL:
                    return {
                        ...state,
                        isLoading: false,
                        error: action.payload,
                    };
        case GET_ALLLABS_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                labs: action.payload,
            };
        case GET_ALLLABS_LIST_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
            //BLOCK LAB
            case DELETE_LAB_FAIL:
                return {
                    ...state,
                    isLoading: false,
                    error: action.payload,
                };
            case DELETE_LAB_SUCCESS:
                console.log(action.payload)
                console.log("lab blocked")
                return {
                    ...state,
                    labs: state.labs.filter(
                    lab => lab.email.toString() !== action.payload.email.toString()
                    ),
                
            }
            case UNBLOCK_LAB_FAIL:
                return {
                    ...state,
                    isLoading: false,
                    error: action.payload,
                };
            case UNBLOCK_LAB_SUCCESS:
                console.log(action.payload)
                console.log("lab blocked")
                return {
                    ...state,
                    labs: state.labs.filter(
                    lab => lab.email.toString() !== action.payload.email.toString()
                    ),
                
            }
            //DLETE LAB
            case DELETEP_LAB_FAIL:
                return {
                    ...state,
                    isLoading: false,
                    error: action.payload,
                };
            case DELETEP_LAB_SUCCESS:
                console.log(action.payload)
                console.log("lab blocked")
                return {
                    ...state,
                    labs: state.labs.filter(
                    lab => lab.email.toString() !== action.payload.email.toString()
                    ),
                
            }
            //VERIFY LAB
            case VERIFY_LAB_FAIL:
                return {
                    ...state,
                    isLoading: false,
                    error: action.payload,
                };
            case VERIFY_LAB_SUCCESS:
                console.log(action.payload)
                console.log("lab Verified")
                return {
                    ...state,
                    labs: state.labs.filter(
                    lab => lab.userData.email.toString() !== action.payload.userData.email.toString()
                    ),
                
            }
            // Lab Details
     case GET_LAB_DETAIL:
         return {
          ...state,
          isLoading: true,
        };
      case GET_LAB_DETAIL_SUCCESS:
        return {
          ...state,
          lab: action.payload,
          isLoading: false,
        };
  
      case GET_LAB_DETAIL_FAIL:
        return {
          ...state,
          error: action.payload,
        };
        //UPDATE SINGLE LAB
        case UPDATE_LAB_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
            case UPDATE_LAB_SUCCESS:
                console.log("data from reducer"+action.payload)
                return { 
                    ...state,
                    isLoading: false,
                    labs: state.labs.map(lab =>
                      lab.userData.email.toString() === action.payload.userData.email.toString()
                        ? { lab, ...action.payload }
                        : lab
                    ),
                  
                        
                };
        case UPLOAD_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
            case UPLOAD_SUCCESS:
                console.log("data from reducer"+action.payload)
                return { 
                    ...state,
                    isLoading: false,
                    file: action.payload,

                   
                    
                        
                };
  
            
            
        default:
            return state;

}
}

export default LabReducer;